module.exports = __webpack_public_path__ + "static/img/player_head_9.213a6e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/user/player_head_9.jpg
// module id = TUfM
// module chunks = 1